import React from 'react';
import JavascriptObjectsDefinitions from './JavascriptObjectsDefinitions.jsx';
import JavascriptObjectsProperties from './JavascriptObjectsProperties.jsx';
import JavascriptObjectsMethods from './JavascriptObjectsMethods.jsx';
import JavascriptObjectsDisplay from './JavascriptObjectsDisplay.jsx';
import JavascriptObjectsConstructors from './JavascriptObjectsConstructors.jsx';
import JavascriptObjectsThis from './JavascriptObjectsThis.jsx';
import JavascriptObjectsDestructuring from './JavascriptObjectsDestructuring.jsx';
import JavascriptObjectsPrototypes from './JavascriptObjectsPrototypes.jsx';
import JavascriptObjectsIterations from './JavascriptObjectsIterations.jsx';
import JavascriptObjectsManagement from './JavascriptObjectsManagement.jsx';
import JavascriptObjectsGetSet from './JavascriptObjectsGetSet.jsx';
import JavascriptObjectsProtection from './JavascriptObjectsProtection.jsx';
import JavascriptObjectsReference from './JavascriptObjectsReference.jsx';

export default function JsObjects() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Objects</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/objects/definitions' className='underline'>Object Definitions</a></li>
<li><a href='/javascript/objects/properties' className='underline'>Object Properties</a></li>
<li><a href='/javascript/objects/methods' className='underline'>Object Methods</a></li>
<li><a href='/javascript/objects/display' className='underline'>Object Display</a></li>
<li><a href='/javascript/objects/constructors' className='underline'>Object Constructors</a></li>
<li><a href='/javascript/objects/this' className='underline'>Object this</a></li>
<li><a href='/javascript/objects/destructuring' className='underline'>Object Destructuring</a></li>
<li><a href='/javascript/objects/prototypes' className='underline'>Object Prototypes</a></li>
<li><a href='/javascript/objects/iterations' className='underline'>Object Iterations</a></li>
<li><a href='/javascript/objects/management' className='underline'>Object Management</a></li>
<li><a href='/javascript/objects/get-set' className='underline'>Object Get / Set</a></li>
<li><a href='/javascript/objects/protection' className='underline'>Object Protection</a></li>
<li><a href='/javascript/objects/reference' className='underline'>Object Reference</a></li>
      </ul>
    </div>
  );
}
